import React from 'react'

import HSGCard from '../../../../Components/HSGCard/HSGCard'

import '../SmartClinic.css'

class StudentCard extends React.Component{

    constructor(props){
        super(props)
        this.state = {}
    }

    componentWillMount() {}

    componentDidMount() {}

    componentWillReceiveProps(nextProps) {}

    getValueInputDivision = (className, label, input, defaultInput) => (
        input || defaultInput ?
        <div className={className}>
            <label className = "hsg-sv-label">{label}</label>
            <label className = "hsg-sv-input">{`${input ? input : defaultInput}`}</label>
        </div> : null
    )

    formatCommaStrings = (string) => (
        string ? string.trim().slice(0,-1).toUpperCase() : null
    )


    _renderStudentBasicInfo = (student) => {

        let studentClass = student.class ? (student.class + (student.section ? ' | ' + student.section : '')) : 'NA'

        return (
            <div className="row col-md-12 col-sm-12 col-xs-12 padding-5">     
                <div className="col-md-12 col-sm-12 col-xs-12">
                    <label className = "hsg-sv-label">{'Basic Info'}</label>
                    {/* <label className = "hsg-sv-label right" onClick = {() => this.props.openStudentProfile(student.student_id)}>{'View Profile'}</label> */}
                </div>         
                <div className="col-md-12 col-sm-12 col-xs-12 padding-10 margin-left-20">     
                    {this.getValueInputDivision("row col-md-2 col-sm-12 col-xs-12", 'Class: ', studentClass, 'NA')}
                    {this.getValueInputDivision("row col-md-3 col-sm-12 col-xs-12", 'HSG Id: ', student.uuid, 'NA')}
                    {this.getValueInputDivision("row col-md-2 col-sm-12 col-xs-12", 'Gender: ', student.gender, 'NA')}
                    {this.getValueInputDivision("row col-md-3 col-sm-12 col-xs-12", 'DOB: ', student.dob, 'NA')}
                    {this.getValueInputDivision("row col-md-3 col-sm-12 col-xs-12", 'Admission Number: ', student.admission_number, 'NA')}
                </div>
            </div>
        )
    }

    _renderStudentParentInfo = (parent) => {

        let parentName = parent && parent.parent_name ? parent.parent_name.trim().toUpperCase() : 'NA'
        let parentArray

        try {
            parentArray = JSON.parse(parent.json_value.parent)
        }catch(e){
            parentArray = null
        }

        return (
            <div className="row col-md-12 col-sm-12 col-xs-12 padding-5">     
                <div className="col-md-12 col-sm-12 col-xs-12">
                    <label className = "hsg-sv-label">{'Parent Info'}</label>
                </div>         
                <div className="col-md-12 col-sm-12 col-xs-12 padding-10 margin-left-20">  
    
                    {
                        this._renderParentInfo(parent, 999)
                    }
                    {
                        parentArray && parentArray.map((parent, index) => (
                            this._renderParentInfo(parent, index)
                        ))
                    }

                </div>
            </div>
        )
    }

    _renderParentInfo = (parent, index) => {
        let parentName = parent && parent.parent_name ? parent.parent_name.trim().toUpperCase() : 'NA'

        return (
            <div key = {index} className = "col-md-12 col-sm-12 col-xs-12">  
                {this.getValueInputDivision("row col-md-3 col-sm-12 col-xs-12", 'Name: ', parentName, 'NA')}
                {this.getValueInputDivision("row col-md-4 col-sm-12 col-xs-12", 'Email: ', parent.user_email, 'NA')}
                {this.getValueInputDivision("row col-md-2 col-sm-12 col-xs-12", 'Contact: ', parent.user_phone_number, 'NA')}
                {this.getValueInputDivision("row col-md-2 col-sm-12 col-xs-12", 'Other: ', parent.emergencyContact, null)}
            </div>
        )
    }

    _renderStudentMedicalInfo = (medicalInfo) => {

        let ailment = '' 
        ailment = Boolean(medicalInfo.previousIllnessRecord) ? medicalInfo.previousIllnessRecord : ailment
        ailment = Boolean(ailment) && Boolean(medicalInfo.ailment) ? ailment + ', ' + medicalInfo.ailment :  Boolean(ailment) ? ailment : Boolean(medicalInfo.ailment) ? medicalInfo.ailment : null  

        return (
            <div className="row col-md-12 col-sm-12 col-xs-12 padding-5">     
                <div className="col-md-12 col-sm-12 col-xs-12">
                    <label className = "hsg-sv-label">{'Medical Info'}</label>
                </div>         
                <div className="col-md-12 col-sm-12 col-xs-12 padding-10 margin-left-20">  
    
                    {this.getValueInputDivision("row col-md-6 col-sm-12 col-xs-12", 'Food Allergies: ', medicalInfo.foodAllergies, null)}
                    {this.getValueInputDivision("row col-md-6 col-sm-12 col-xs-12", 'Medicine Allergies: ', medicalInfo.medicineAllergies, null)}
                    {this.getValueInputDivision("row col-md-6 col-sm-12 col-xs-12", 'Others: ', medicalInfo.otherAllergies && medicalInfo.otherAllergies.toUpperCase() || null , null)}
                    {this.getValueInputDivision("row col-md-6 col-sm-12 col-xs-12", 'Any Previous Illness: ', ailment && ailment.toUpperCase() || null, null)}
                    {this.getValueInputDivision("row col-md-2 col-sm-12 col-xs-12", 'Blood Group: ', medicalInfo.bloodGroup, null)}
                    {this.getValueInputDivision("row col-md-10 col-sm-12 col-xs-12", 'Remarks: ', medicalInfo.remarks, null)}

                </div>
            </div>
        )
    }

    render(){

        let {episodeList, studentProfile} = this.props

        return (
            <HSGCard
                headingLeft = {studentProfile.name}
                headingRight = {
                    <div>
                        <label className = "hsg-sv-label right" style = {{color: '#a0c2ff', cursor: "pointer"}} onClick = {() => this.props.closeStudentProfile()}>{'Close Profile'}</label>
                        <label className = "hsg-sv-label right" style = {{color: '#a0c2ff', cursor: "pointer", paddingRight: 10}} onClick = {() => this.props.toggleEpisodeModal(true)}>{'Add Episode'}</label>
                    </div>
                }
                >

                <div style ={{marginBottom: 10}}></div>

                <div className="hsg-card-details row"> {this._renderStudentBasicInfo(studentProfile)} </div>
                <div className="hsg-card-details row"> {this._renderStudentParentInfo(studentProfile)} </div>
                <div className="hsg-card-details row"> {this._renderStudentMedicalInfo(studentProfile.json_value)} </div>

            </HSGCard>
        )
    }
}

export default StudentCard


// WEBPACK FOOTER //
// ./src/Containers/SmartClinicContainer/Component/Student/StudentCard.js